import { render, staticRenderFns } from "./Dre.vue?vue&type=template&id=d01f2288"
import script from "./Dre.vue?vue&type=script&lang=js"
export * from "./Dre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports